import React from 'react';
import '../App.css';
import NavBar from './NavBar';
import 'bootstrap/dist/css/bootstrap.min.css';
import { Container } from 'react-bootstrap';
import { Outlet } from 'react-router-dom';
import Main from './Main';
import FootBar from './FootBar';

function App() {
  return (
    <>
      <NavBar />
      <hr style={{marginTop: '0.5em'}}/>
      <Container>
         <Outlet />
      </Container>
      <FootBar />
    </>
    
  );
}

export default App;
